import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { isCustomerScanEnabled } from '../config/customerFeatureFlags.js';
import { useCustomerFeatureFlags } from '../features/flags/useCustomerFeatureFlags.js';
import { resolvePlatformHubPath } from '../features/shop/resolveShopHref.js';

interface CustomerScanRouteGuardProps {
  readonly children: ReactNode;
  readonly loadingFallback: ReactNode;
}

/**
 * Boot-only gate for platform `/scan` — redirects when Skenovat is disabled.
 */
export function CustomerScanRouteGuard({
  children,
  loadingFallback,
}: CustomerScanRouteGuardProps): JSX.Element {
  const { flags, flagsReady } = useCustomerFeatureFlags();

  if (!flagsReady) {
    return <>{loadingFallback}</>;
  }

  if (!isCustomerScanEnabled(flags)) {
    return <Navigate to={resolvePlatformHubPath(flags)} replace />;
  }

  return <>{children}</>;
}
